import React, { useEffect, useRef } from 'react';
import './audioModal.css';

interface AudioModalProps {
  audioUrl: string | null;
  title?: string | null;
  onClose: () => void;
}

/** 通用音频播放弹窗。播放地址为空时保持隐藏状态。 */
const AudioModal: React.FC<AudioModalProps> = ({ audioUrl, title, onClose }) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    if (!audioUrl) return;
    const el = audioRef.current;
    if (!el) return;
    void el.play().catch(() => {
      /* 浏览器可能拦截自动播放，用户可手动点播放 */
    });
  }, [audioUrl]);

  const handleClose = () => {
    const el = audioRef.current;
    if (el) {
      el.pause();
      el.currentTime = 0;
    }
    onClose();
  };

  return (
    <div
      className={`audio-modal${audioUrl ? ' on' : ''}`}
      onClick={handleClose}
      role="presentation"
    >
      <button
        type="button"
        className="am-close"
        onClick={handleClose}
        aria-label="关闭播放"
      >
        ✕
      </button>
      <div
        className="am-content"
        role="dialog"
        aria-modal="true"
        aria-label={title ? `播放 ${title}` : '播放音频'}
        onClick={(e) => e.stopPropagation()}
      >
        {audioUrl ? (
          <>
            {title ? <div className="am-title">{title}</div> : null}
            <audio ref={audioRef} className="am-player" src={audioUrl} controls autoPlay />
          </>
        ) : null}
      </div>
    </div>
  );
};

export default AudioModal;
